/**
 * airan-ntn — Federated Learning Index
 */

export { FedAVG } from './FedAVG.js';
export { FedSGD } from './FedSGD.js';
export { FedProx } from './FedProx.js';
export { createScheduler, selectUEs } from './NtnScheduler.js';

import { FLStrategy, SimConfig, FLAlgorithm } from '../types.js';
import { FedAVG } from './FedAVG.js';
import { FedSGD } from './FedSGD.js';
import { FedProx } from './FedProx.js';

export function createFLStrategy(config: SimConfig): FLStrategy {
  switch (config.flAlgorithm) {
    case 'FedAVG': return new FedAVG();
    case 'FedSGD': return new FedSGD();
    case 'FedProx': return new FedProx();
  }
}